import { createAction, props } from '@ngrx/store';
import { Apk, ApkForm } from '@models/.'
import { ResponseBadRequest } from '@interfaces/.';

export const APK_FIND = createAction('[Apk] Find', props<{ id: string }>());
export const APK_FIND_ALL = createAction('[Apk] Find All', props<{ moduleType?: string | null }>());

export const APK_FIND_SUCCESS = createAction('[Apk] Find Success', props<{ apk: Apk }>());
export const APK_FIND_ALL_SUCCESS = createAction('[Apk] Find All Success', props<{ apkList: Apk[] }>());
export const APK_CREATED_SUCCESS = createAction('[Apk] Create Success', props<{ apk: Apk|null }>());

export const APK_FAILURE = createAction('[Apk] Failure', props<{ error: ResponseBadRequest }>());

export const APK_UPDATE_LOADING = createAction('[Apk] Update Loading', props<{ loading: boolean }>());
export const APK_UPDATE_FORM = createAction('[Apk] Update Form', props<{ apkForm: ApkForm }>());
export const APK_UPDATE_SELECTED = createAction('[Apk] Update Selected', props<{ apkSelected: string[] }>());
export const APK_EDIT_MODE = createAction('[Apk] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const APK_UPDATE_ID = createAction('[Apk] Update Id', props<{ apkId: string|null }>());

export const APK_CREATE_VIEW = createAction('[Apk] Create View');
export const APK_UPDATE_VIEW = createAction('[Apk] Update View', props<{ apkId: string }>());

export const APK_CREATE = createAction('[Apk] Create');
export const APK_UPDATE = createAction('[Apk] Update');
export const APK_REMOVE = createAction('[Apk] Remove', props<{ id: string }>());

export const APK_CREATE_COMPLETED = createAction('[Apk] Create Completed');
export const APK_UPDATE_COMPLETED = createAction('[Apk] Update Completed');
export const APK_REMOVE_COMPLETED = createAction('[Apk] Remove Completed');
export const APK_FIND_ALL_COMPLETED = createAction('[Apk] Find All Completed');

export const APK_RESET = createAction('[Apk] Reset');
export const APK_RESET_FORM = createAction('[Apk] Reset Form');
export const APK_RESET_ERROR = createAction('[Apk] Reset Error');
export const APK_CLEAR_STATE = createAction('[Apk] Clear State');
